const SvgBezprzylgowe60 = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 60 60">
    <path fill="#373737" d="M32 11v8h-4v2H17v15h41v-2H19V23h39v-2H41v-2h-5v-4h15v-4z" />
    <path fill="#373737" d="M2 21v19.36h2V23h7v20h6v6h2v-8h-6V21z" />
  </svg>;
export default SvgBezprzylgowe60;